import { getToken } from '../Utils/Common';
//let apilink = "https://d25c1smh4gyzd4.cloudfront.net"
let apilink = process.env.REACT_APP_BACKEND_API_URI


export function getIndustries() {


    //return fetch(`${process.env.REACT_APP_BASE_URI}/api/annotator/industry`, {
        return fetch(`${apilink}parser/getindustry`, {
        method: 'POST',
        headers: {
            //Authorization: 'Bearer ' + getToken()
            "Content-Type": "application/json"
        },body: JSON.stringify({"tingo":"indusss","token":getToken()})
    })
        .then((response) => response.json())
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}

export function setIndustries(item) {
    item.token = getToken()
    item.logged_userid = getToken()
    return fetch(`${apilink}parser/saveindustry`, {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            //Authorization: 'Bearer ' + getToken()
        },
        body: JSON.stringify(item)
    })
        .then((response) => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}


export function deleteIndustries(item) {
    return fetch(`${process.env.REACT_APP_BASE_URI}/api/annotator/delete_lvindustry`, {
        method: 'DELETE',
        headers: {
            'Content-type': 'application/json',
            Authorization: 'Bearer ' + getToken()
        },
        body: JSON.stringify(item)
    })
        .then((response) => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}

// export function getLVIndustries() {
//     return fetch(`${process.env.REACT_APP_BASE_URI}/api/annotator/lvindustry`, {
//         method: 'GET',
//         headers: {
//             Authorization: 'Bearer ' + getToken()
//         }
//     })
//         .then((response) => response.json())
//         .then((res) => {
//             return res;
//         })
//         .catch((error) => {
//             console.error('Error:', error);
//         });
// }

/*export function setLVIndustries(item) {
    return fetch(`${process.env.REACT_APP_BASE_URI}/api/annotator/save_lvindustry`, {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            Authorization: 'Bearer ' + getToken()
        },
        body: JSON.stringify(item)
    })
        .then((response) => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}*/

/*export function deleteLVIndustries(item) {
    return fetch(`${process.env.REACT_APP_BASE_URI}/api/annotator/delete_lvindustry`, {
        method: 'DELETE',
        headers: {
            'Content-type': 'application/json',
            Authorization: 'Bearer ' + getToken()
        },
        body: JSON.stringify(item)
    })
        .then((response) => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}*/
